import { h } from 'preact';
const EditingBtns = ({ data, handleEdit, handleDelete }) => h("div", { className: "clearfix" },
    h("div", { className: "right" },
        h("div", { class: "columns" },
            h("div", { className: "btn-stack--sm" },
                h("button", { className: "btn btn--left", onClick: () => {
                        handleEdit(data);
                    } }, "Edit")),
            h("div", { className: "btn-stack--sm" },
                h("button", { className: "btn btn--secondary btn--right", onClick: () => {
                        handleDelete(data);
                    } }, "Delete")))));
export default EditingBtns;
